export const clockFace = [
    "12",
    "\u2022",
    "1",
    "\u2022",
    "2",
    "\u2022",
    "3",
    "\u2022",
    "4",
    "\u2022",
    "5",
    "\u2022",
    "6",
    "\u2022",
    "7",
    "\u2022",
    "8",
    "\u2022",
    "9",
    "\u2022",
    "10",
    "\u2022",
    "11",
    "\u2022",
  ];

  export const angleFace = ['0\u00b0', "\u2022", "30\u00b0", "\u2022", "60\u00b0", "\u2022", "90\u00b0", "\u2022", "120\u00b0", "\u2022", "150\u00b0", "\u2022", "180\u00b0", "\u2022", "-150\u00b0", "\u2022", "-120\u00b0", "\u2022", "-90\u00b0", "\u2022", "-60\u00b0", "\u2022", "-30\u00b0", "\u2022",]
  export const angleFaceCounterClockwise = ['0\u00b0', "\u2022", "-30\u00b0", "\u2022", "-60\u00b0", "\u2022", "-90\u00b0", "\u2022", "-120\u00b0", "\u2022", "-150\u00b0", "\u2022", "-180\u00b0", "\u2022", "150\u00b0", "\u2022", "120\u00b0", "\u2022", "90\u00b0", "\u2022", "60\u00b0", "\u2022", "30\u00b0", "\u2022",]
